import { useState } from 'react';
export function useDamageHealForm() {
    const [formState, setFormState] = useState(null);
    const [value, setValue] = useState(1);
    const openForm = (type) => {
        setFormState(type);
        setValue(1);
    };
    const closeForm = () => {
        setFormState(null);
        setValue(1);
    };
    const increment = () => setValue((v) => v + 1);
    const decrement = () => setValue((v) => Math.max(0, v - 1));
    const handleChange = (e) => {
        const val = Number(e.target.value);
        setValue(Number.isNaN(val) ? 0 : val);
    };
    return {
        formState,
        value,
        openForm,
        closeForm,
        increment,
        decrement,
        handleChange,
    };
}
